module.exports = __webpack_public_path__ + "img/Butterfly_00301.8f7d8ebe.png";